"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeachingBubble = void 0;
var Utilities_1 = require("../../Utilities");
var TeachingBubble_base_1 = require("./TeachingBubble.base");
var TeachingBubble_styles_1 = require("./TeachingBubble.styles");
exports.TeachingBubble = (0, Utilities_1.styled)(TeachingBubble_base_1.TeachingBubbleBase, TeachingBubble_styles_1.getStyles, undefined, { scope: 'TeachingBubble' });
//# sourceMappingURL=TeachingBubble.js.map